import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mobile",
  "use": "mobile-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"mobile\"><circle cx=\"16\" cy=\"26.5\" r=\"1.5\" /><path d=\"M24 0H8a1 1 0 00-1 1v30a1 1 0 001 1h16a1 1 0 001-1V1a1 1 0 00-1-1zm-1 30H9V2h14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/mobile.svg
// module id = aynh
// module chunks = 39 44